import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Lightbox from 'react-images';
import { enableBodyScroll } from 'body-scroll-lock';
import SquareCard from './SquareCard';
import { CloseLightbox } from './InstagramSlider';
import SliderArrow from './SliderArrow';

export default function ReviewSlider({
  images,
  toggleLightbox,
  showLightbox,
  setImageIndex,
  imageIndex,
}) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SliderArrow direction="prev" />,
    nextArrow: <SliderArrow direction="next" />,
  };

  const cards = images.map((image, ind) => (
    <SquareCard
      key={ind}
      image={image.small_image_url}
      toggleLightbox={toggleLightbox}
      setImageIndex={setImageIndex}
      index={ind}
    />
  ));

  return (
    <Fragment>
      <Lightbox
        onClose={() => toggleLightbox(false)}
        onClickNext={() => setImageIndex(imageIndex + 1)}
        onClickPrev={() => setImageIndex(imageIndex - 1)}
        currentImage={imageIndex}
        isOpen={showLightbox}
        images={images.map(image => ({
          src: image.large_image_url,
          // caption: post.caption,
        }))}
        onClickThumbnail={e => setImageIndex(e)}
        customControls={[
          <CloseLightbox
            onClick={() => {
              toggleLightbox(false);
              // I'm sorry... There was no other way...
              setTimeout(() => {
                document.querySelector('body').style.overflow = '';
              }, 0);
            }}
          />,
        ]}
        closeButtonTitle="closeLightbox"
        leftArrowTitle="leftLightboxArrow"
        rightArrowTitle="rightLightboxArrow"
        showImageCount={false}
        showThumbnails
      />

      <div className="slider-container square-slider">
        {images.length ? (
          <Slider {...settings}>{cards}</Slider>
        ) : (
          <div className="slider-fallback">
            <p>No Photos Available</p>
          </div>
        )}
      </div>
    </Fragment>
  );
}

ReviewSlider.propTypes = {
  images: PropTypes.array,
  toggleLightbox: PropTypes.func.isRequired,
  showLightbox: PropTypes.bool.isRequired,
  setImageIndex: PropTypes.func.isRequired,
  imageIndex: PropTypes.number.isRequired,
};
